import { getUpdatedVariantIds } from "./getUpdatedVariantIds";

export default (state, { payload: { variantId, isOptedIn } }) => {
  const { variantIds } = state;

  return {
    ...state,
    variantIds: getUpdatedVariantIds(variantIds, variantId, isOptedIn)
  };
};
